<div class="filters">
  <div class="filter-header" [ngClass]="classFlag ? 'headerFilter' : ''">
    <div>
      @if (dateSelected) {
        <span>
          <div class="back-button" (click)="back()"></div>
          <!-- <img src="../../../../assets/images/back.svg" class="iconClass" (click)="back()" /> -->
        </span>
      }
    </div>
    <div class="report-generation-txt" [ngClass]="classFlag ? 'apply' : ''">
      Report Generation
    </div>
    <div class="">
      <div class="close-button" (click)="close()"></div>
      <!-- <img src="assets/images/close-circle.svg" class="cursor-pointer close" alt="" /> -->
    </div>
  </div>

  @if (!dateSelected) {
    <div class="selectType">
      <mat-select [(value)]="selected" placeholder="Select Date Type" class="selectClass dateFilter"
        (selectionChange)="dateType($event)">
        <mat-option value="Created Date" class="option">Created Date</mat-option>
        <mat-option value="Updated Date" class="option">Updated Date</mat-option>
        <!-- <mat-option value="Onboarded Date" class="option">Onboarding Date</mat-option> -->
      </mat-select>
    </div>
  }
  @if (dateSelected) {
    <form class="user-form" [formGroup]="filterForm" (submit)="onSubmit()" autocomplete="off">
      <mat-form-field class="date-picker">
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Start date" [value]="startDates" (dateChange)="startDateChange($event)" />
          <input matEndDate placeholder="End date" [value]="endDates" (dateChange)="endDateChange($event)" />
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker">
        </mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <div class="align-generate-btn button" [ngClass]="!classFlag ? 'buttonClassFlag' : ''">
        <button type="submit" class="create-action">
          <span>Generate</span>
        </button>
      </div>
    </form>
  }


</div>